import clsx from "clsx";

  // Table styles object
   const tableStyles = {
    container: "box p-4 overflow-x-auto intro-y lg:overflow-x-auto col-span-12 bg-white dark:bg-gray-red-200, border-2 border-gray-200 dark:border-gray-600 rounded-lg",
    table: "border-spacing-y-[2px] border-separate -mt-0 w-full",
    headerCell: clsx(
      "text-left border-b",
      "border-gray-200/60",
      "font-medium text-gray-800 bg-white",
      "dark:bg-gray-800 dark:border-gray-600 dark:text-gray-100",
      "p-2 whitespace-nowrap"
    ),
    bodyCell: clsx(
      "border-b border-gray-200/60",
      "bg-white text-gray-700",
      "shadow-[1px_1px_3px_rgba(0,0,0,0.05)]",
      "dark:bg-gray-800 dark:border-gray-600 dark:text-gray-100",
      "p-2 pr-4",
      "whitespace-nowrap"
    ),
    paginationContainer: "flex items-center justify-between mt-4",
    select: clsx(
      "px-3 py-1.5 border rounded-lg",
      "bg-white text-gray-700 border-gray-200",
      "dark:bg-gray-800 dark:text-gray-100 dark:border-gray-600",
      "appearance-none",
      "pr-12",
      "mr-2",
      "pl-2",
      "bg-[url('data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2024%2024%22%20stroke%3D%22%23475569%22%3E%3Cpath%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%222%22%20d%3D%22M19%209l-7%207-7-7%22%2F%3E%3C%2Fsvg%3E')]",
      "bg-[length:1.25rem_1.25rem]",
      "bg-no-repeat",
      "bg-[right_0.5rem_center]",
      "hover:border-gray-400",
      "focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary"
    ),
    pageInfo: "text-sm text-slate-600 dark:text-slate-400",
    button: clsx(
      "px-4 py-2 text-sm rounded-lg border",
      "bg-white text-gray-700 border-gray-200",
      "hover:bg-gray-100",
      "dark:bg-gray-800 dark:text-gray-100 dark:border-gray-600",
      "dark:hover:bg-gray-700",
      "disabled:opacity-50 disabled:cursor-not-allowed"
    )
  };

  export default tableStyles;
